export const DINNER_OFFER_END = "2026-11-15";
export const DINNER_OFFER_NOTE = "Dinner for Two $100 with Caymus";

export function isDinnerOfferActive(now = new Date()): boolean {
  return now >= new Date("2026-10-16T00:00:00-07:00") && now < new Date("2026-11-16T00:00:00-08:00");
}

export function isDinnerOfferDate(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= "2026-10-16" && date <= DINNER_OFFER_END;
}

export function reservationEventId(eventName: string, reservationId: unknown): string | undefined {
  if (!["reservation_completed", "lead_captured"].includes(eventName)) return undefined;
  if (typeof reservationId !== "string" || !/^[a-zA-Z0-9_-]{1,80}$/.test(reservationId)) return undefined;
  return `${eventName}_${reservationId}`;
}
